export default __webpack_public_path__ + "static/media/647.46ad2437.png";